import {
  createFrontendModule,
  ApiBlueprint,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  errorApiRef,
  storageApiRef,
} from '@backstage/frontend-plugin-api';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';

// Sem isso, o StorageApi default (WebStorage) fica só no localStorage do
// browser — favoritos (estrela ★ no catálogo) marcados no desktop não
// aparecem no mobile e vice-versa, cada aparelho com seu próprio
// localStorage isolado (achado 2026-07-14). UserSettingsStorage persiste no
// Postgres via @backstage/plugin-user-settings-backend, por usuário
// autenticado — sincroniza entre qualquer dispositivo/browser.
//
// signalApi (opcional na classe, só usado pra invalidar cache em tempo real
// entre abas/sessões) fica de fora de propósito: este app não registra
// plugin.signal.service no frontend (só o backend de signals, consumido
// hoje só por notifications/announcements) — passar a dep obrigaria
// registrar signalApiRef à toa. Sem ele, ainda funciona: só perde o
// "atualiza sem F5" entre abas abertas simultaneamente.
const persistentStorageApi = ApiBlueprint.make({
  name: 'app',
  params: define =>
    define(
      createApiFactory({
        api: storageApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          identityApi: identityApiRef,
          errorApi: errorApiRef,
        },
        factory: ({ discoveryApi, fetchApi, identityApi, errorApi }) =>
          UserSettingsStorage.create({ discoveryApi, fetchApi, identityApi, errorApi }),
      }),
    ),
});

export const persistentStorageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [persistentStorageApi],
});
